// This file contains configuration for handling error states from API after a request fails.

const getFirstArrayMessage = (value) => {
  if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
    return value[0];
  }

  return null;
};

export const getApiErrorMessage = (errorOrData, fallback = 'Something went wrong') => {
  const data = errorOrData?.response?.data ?? errorOrData;

  if (!data) return fallback;

  if (typeof data === 'string') return data;

  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;
  if (typeof data.message === 'string' && data.message.trim()) return data.message;

  const nonFieldError = getFirstArrayMessage(data.non_field_errors);
  if (nonFieldError) return nonFieldError;

  const fieldError = Object.entries(data).find(
    ([key, value]) => !['detail', 'message', 'non_field_errors', 'error'].includes(key) && getFirstArrayMessage(value)
  );

  if (fieldError) return getFirstArrayMessage(fieldError[1]);

  if (data.error) {
    return typeof data.error === 'string' ? data.error : JSON.stringify(data.error);
  }

  return fallback;
};

const handleApiError = (error) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    console.warn('[Axios Error]', error, error.response);
  }

  if (!error.response) return 'Something went wrong';

  const { response } = error;

  switch (response.status) {
    case 400:
      return getApiErrorMessage(error, 'Something went wrong');
    case 404:
      return getApiErrorMessage(error, 'Resource not found');
    case 409:
      return getApiErrorMessage(error, 'A duplicate already eists');
    default:
      return 'Something went wrong';
  }
};

export default handleApiError;
